<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  name: {
    type: String,
    required: true,
    default: '',
  },
  label: {
    type: String,
    default: '',
  },
  placeholder: {
    type: String,
    default: '',
  },
  options: {
    type: Object,
    required: true,
    default: () => ({}),
  },
  validation: {
    type: String,
    default: '',
  },
  defaultValue: {
    type: [String, Number],
    default: '',
  },
  multiple: {
    type: Boolean,
    default: false,
  },
  behavior: {
    type: String,
    default: '',
  },
  disabled: {
    type: Boolean,
    default: false,
  },
});

const { tm } = useI18n();

const placeholderBind = computed(() => {
  return props.placeholder !== '' ? props.placeholder : tm('general.makeYourChoice');
});
</script>

<template>
  <FormKit
    :id="name"
    type="dropdown"
    :name="name"
    :label="label"
    :validation="validation"
    validation-visibility="dirty"
    :placeholder="placeholderBind"
    :options="options"
    :value="defaultValue"
    :multiple="multiple"
    selection-removable
    open-on-remove
    :behavior="behavior"
    :close-on-select="true"
    :disabled="disabled"
    open-on-focus
  />
</template>

<style lang="scss">
@import '~bootstrap/scss/functions';
@import '~bootstrap/scss/variables';
@import '~bootstrap/scss/mixins';
@import '@/styles/base/typography';

.formkit-option,
.formkit-selections-item {
  font-family: var(--font-medium);
  color: var(--theme-font-color-100);
}

.formkit-selector {
  min-height: 4.8rem;
}
</style>
